module.exports = __webpack_public_path__ + "static/media/19ESCAP30.c7316ea4.jpg";